<template>
  <v-container class="grey-lighten-3 full-height">
    <v-row justify="center">
      <v-col cols="12" xl="10">
        <v-sheet class="report-paper pa-6" elevation="3" id="printable-area">
          <div class="invoice-container">
            <div class="invoice-content">
              <table style="width: 100%; border-collapse: collapse;">
                <thead>
                  <tr v-if="invoiceHeader">
                    <td colspan="100%">
                      <div style="display: flex; justify-content: flex-end; align-items: flex-start; padding-bottom: 10px; margin-bottom: 16px;">
                        <img
                          v-if="requisitionData?.branch?.company?.logo"
                          :src="`${getFileServerUrl}${requisitionData.branch.company.logo}`"
                          class="logo-img"
                          alt="Logo"
                          style="max-height: 80px;"
                        >
                      </div>
                    </td>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td colspan="100%">
                      <div class="header-table" style="font-size: 12px; margin-top: 10px;">
                        <div style="display: flex; justify-content: center;">
                          <h1 style="font-size: 16px; text-decoration: underline;">General Requisition</h1>
                        </div>

                        <div style="display: flex; justify-content: space-between; margin-bottom: 4px;">
                          <div>
                            <p><strong>Department:</strong> {{ requisitionData?.department?.name || '-' }}</p>
                            <p><strong>Warehouse:</strong> {{ requisitionData?.warehouse?.name || '-' }}</p>
                          </div>
                          <div>
                            <p><strong>Requisition:</strong> {{ requisitionData?.code || '-' }}</p>
                            <p><strong>Requisition Date:</strong> {{ formatDateView(requisitionData?.requisition_date) }}</p>
                            <p><strong>Require Date:</strong> {{ formatDateView(requisitionData?.require_date) }}</p>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td class="details-table" colspan="100%" style="border: none;">
                      <table class="dep-table details-table" style="width: 100%; border-collapse: collapse;">
                        <thead>
                        <tr>
                          <th style="display:flex; justify-content: start; margin-bottom: 4px; border:none; padding: 3px">
                            Item Details
                          </th>
                        </tr>
                        </thead>
                      </table>
                    </td>
                  </tr>

                  <tr>
                    <td class="details-table" colspan="100%" style="border: none;">
                      <table class="dep-table details-table" style="width: 100%; border-collapse: collapse;">
                        <thead>
                          <tr>
                            <th>SN</th>
                            <th>Code</th>
                            <th>Item</th>
                            <th>Quantity</th>
                            <th>Unit</th>
                            <th>Approval Qty</th>
                            <th>Delivery Qty</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in requisitionData?.requisition_details || []" :key="item.id">
                            <td style="text-align: center;">{{ index + 1 }}</td>
                            <td style="text-align: center;">{{ item.product?.code || '-' }}</td>
                            <td>{{ item.product?.name || '-' }}</td>
                            <td style="text-align: center;">{{ item.qty || 0 }}</td>
                            <td style="text-align: center;">{{ item.product?.unit?.name || '-' }}</td>
                            <td style="text-align: center;">{{ item.approval_qty || 0 }}</td>
                            <td style="text-align: center;">{{ item.delivery_qty || 0 }}</td>
                          </tr>
                          <tr v-if="!requisitionData?.requisition_details?.length">
                            <td colspan="7" style="text-align: center;">No product details found</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="100%" class="details-table" style="border: none;">
                      <div style="margin-top: 10px;">
                        <v-row>
                          <v-col cols="4" class="text-center">
                            <div class="signature-line"></div>
                            <div class="signature-label">Prepared By</div>
                          </v-col>
                          <v-col cols="4" class="text-center">
                            <div class="signature-line"></div>
                            <div class="signature-label">Authorized By</div>
                          </v-col>
                          <v-col cols="4" class="text-center">
                            <div class="signature-line"></div>
                            <div class="signature-label">Received By</div>
                          </v-col>
                        </v-row>
                      </div>
                    </td>
                  </tr>
                </tbody>

                <tfoot v-if="invoiceHeader">
                <tr>
                  <td colspan="100%" style="border:none">
                    <div style="width:100%;height: 100px;">&nbsp;</div>
                  </td>
                </tr>
                </tfoot>
              </table>
            </div>

          <div class="invoice-footer">
            <!-- <img v-if="orderInvoice?.branch?.company?.footer_image && invoiceHeader" :src="`${getFileServerUrl}${orderInvoice?.branch?.company?.footer_image}`" alt="" style="width: 100%; display: block;"> -->
            <div class="invoice-footer" v-if="invoiceHeader" style="margin-left:10px; margin-bottom:10px; color: #343591;">
              <p style="font-size: 13px; font-weight: 500; display: flex; align-items: center; gap:4px">
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path fill="currentColor" d="M12 11.5A2.5 2.5 0 0 1 9.5 9A2.5 2.5 0 0 1 12 6.5A2.5 2.5 0 0 1 14.5 9a2.5 2.5 0 0 1-2.5 2.5M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7" />
                </svg>

                <span>{{ requisitionData?.branch?.company?.address }}</span>
              </p>

              <p style="font-size: 13px; font-weight: 500; display: flex; align-items: center; gap:4px">
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path fill="currentColor" d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24c1.12.37 2.33.57 3.57.57c.55 0 1 .45 1 1V20c0 .55-.45 1-1 1c-9.39 0-17-7.61-17-17c0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1c0 1.25.2 2.45.57 3.57c.11.35.03.74-.25 1.02z" />
                </svg>

                <strong>Phone: </strong>  +880 9610-993393, +880 2 222288648, www.remexingredient.com | www.remexcorp.com
              </p>
            </div>
          </div>
          </div>

        </v-sheet>
      </v-col>
    </v-row>

    <v-row justify="center" class="d-print-none mt-4">
      <v-col cols="12" style="display: flex; justify-content: center;">
        <v-btn color="primary" prepend-icon="mdi-printer" @click="print(0)">
          Print without pad
        </v-btn>
        <v-btn color="primary" prepend-icon="mdi-printer" class="ml-2" @click="print(1)">
          Print with pad
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { onMounted, ref, computed } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { formatDateView } from "@/plugins/helpers";

const route = useRoute();
const store = useStore();

const requisitionData = ref(null);
const pagePadding = ref(0);
const invoiceHeader = ref(true);

const getFileServerUrl = computed(() => store.getters.getFileServerUrl || "");

const print = (isPad) => {
  invoiceHeader.value = isPad === 1;
  pagePadding.value = isPad === 1 ? 0 : 100;

  setTimeout(() => {
    const printContent = document.getElementById("printable-area").innerHTML;
    const printWindow = window.open("", "_blank", `width=${screen.width}, height=${screen.height}`);

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>General Requisition</title>
        <style>
          * { margin: 0; padding: 0; box-sizing: border-box; }
          @page { size: A4; margin: ${pagePadding.value}px 0; }
          html, body { margin: 0; padding: 0; width: 100%; height: auto; }
          body { font-family: sans-serif; background: #fff; color: #000; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
          .report-paper, .invoice-container, .invoice-content { width: 100%; margin: 0; padding: 0 !important; background: #fff; }
          table { width: 100%; border-collapse: collapse; font-size: 12px; }
          .header-table, .details-table { padding: 0 32px; }
          .invoice-footer {
            margin-top: auto;
            position: fixed;
            left; 0;
            bottom: 0px;
            width: 100%;
          }
          th, td { border: 1px solid #E0E0E0; padding: 2px; vertical-align: middle; }
          th { background: #e0e0e0; text-align: center; font-weight: bold; }
          .text-center { text-align: center; }
          .signature-line { border-bottom: 1px solid #000; margin: 50px 0 8px; height: 20px; }
          .signature-label { text-transform: uppercase; font-weight: bold; font-size: 12px; }
          img { max-width: 100%; height: auto; }
          .v-row { display: flex !important; flex-wrap: wrap !important; width: 100%; }
          .v-col-4 { flex: 0 0 33.333333% !important; max-width: 33.333333% !important; padding: 0 12px; }
          @media print { body { margin: 0; padding: 0; } }
        </style>
      </head>
      <body>${printContent}</body>
      </html>
    `);

    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 500);

    invoiceHeader.value = true;
    pagePadding.value = 0;
  }, 500);
};

onMounted(() => {
  const id = route.params.id;
  if (id) {
    store.dispatch("getInvRequisitionById", id).then((res) => {
      requisitionData.value = res;
    });
  }
});
</script>

<style scoped>
.full-height { min-height: 60vh; }
.grey-lighten-3 { background-color: #eeeeee !important; }
.report-paper { background: white; }
.dep-table { width: 100%; border-collapse: collapse; font-size: 12px; }
.dep-table th, .dep-table td { border: 1px solid #000; padding: 2px; font-size: 12px; }
.dep-table th { background: #e0e0e0; }
.text-center { text-align: center; }
.signature-line { border-bottom: 1px solid #000; margin: 50px 0 8px; height: 20px; }
.signature-label { text-transform: uppercase; font-weight: bold; font-size: 12px; }
</style>
